import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_56ecbfca from 'nuxt_plugin_plugin_56ecbfca' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_recaptcha_65d34e32 from 'nuxt_plugin_recaptcha_65d34e32' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_gtm_0c9c6964 from 'nuxt_plugin_gtm_0c9c6964' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_nuxtplugin455c229e_248fd5f5 from 'nuxt_plugin_nuxtplugin455c229e_248fd5f5' // Source: ./nuxt.plugin.455c229e.js (mode: 'server')
import nuxt_plugin_vuescrollto_69f8eede from 'nuxt_plugin_vuescrollto_69f8eede' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_39cf7620 from 'nuxt_plugin_cookieuniversalnuxt_39cf7620' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_09ab66c3 from 'nuxt_plugin_pluginutils_09ab66c3' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginseo_598c2ed7 from 'nuxt_plugin_pluginseo_598c2ed7' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_026d4f4e from 'nuxt_plugin_pluginrouting_026d4f4e' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_d8eee23e from 'nuxt_plugin_pluginmain_d8eee23e' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_distplugind555f224_52874b51 from 'nuxt_plugin_distplugind555f224_52874b51' // Source: ./dist.plugin.d555f224.mjs (mode: 'all')
import nuxt_plugin_image_beee791a from 'nuxt_plugin_image_beee791a' // Source: ./image.js (mode: 'all')
import nuxt_plugin_coreplugin3cbad86a_42542c88 from 'nuxt_plugin_coreplugin3cbad86a_42542c88' // Source: ./core.plugin.3cbad86a.ts (mode: 'all')
import nuxt_plugin_pluginse2etesting99e2c82a_6527f86e from 'nuxt_plugin_pluginse2etesting99e2c82a_6527f86e' // Source: ./plugins.e2e-testing.99e2c82a.js (mode: 'all')
import nuxt_plugin_deviceplugin_27076603 from 'nuxt_plugin_deviceplugin_27076603' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_workbox_440b04d8 from 'nuxt_plugin_workbox_440b04d8' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_2716f0a7 from 'nuxt_plugin_metaplugin_2716f0a7' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_2bbe961b from 'nuxt_plugin_iconplugin_2bbe961b' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_tokenexpired_ca1e20ca from 'nuxt_plugin_tokenexpired_ca1e20ca' // Source: ../plugins/token-expired (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_fcPlugin_5a846bc6 from 'nuxt_plugin_fcPlugin_5a846bc6' // Source: ../plugins/fcPlugin (mode: 'all')
import nuxt_plugin_dompurify_9e093c4a from 'nuxt_plugin_dompurify_9e093c4a' // Source: ../plugins/dompurify (mode: 'all')
import nuxt_plugin_storeConfigPlugin_234467e0 from 'nuxt_plugin_storeConfigPlugin_234467e0' // Source: ../plugins/storeConfigPlugin (mode: 'all')
import nuxt_plugin_meta_77b6055c from 'nuxt_plugin_meta_77b6055c' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"贝卡尔特中国","meta":[{"charset":"utf8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"generator","content":"Vue Storefront 2"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-TG79DW5D')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-TG79DW5D&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_56ecbfca === 'function') {
    await nuxt_plugin_plugin_56ecbfca(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_65d34e32 === 'function') {
    await nuxt_plugin_recaptcha_65d34e32(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_0c9c6964 === 'function') {
    await nuxt_plugin_gtm_0c9c6964(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nuxtplugin455c229e_248fd5f5 === 'function') {
    await nuxt_plugin_nuxtplugin455c229e_248fd5f5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_69f8eede === 'function') {
    await nuxt_plugin_vuescrollto_69f8eede(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_39cf7620 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_39cf7620(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_09ab66c3 === 'function') {
    await nuxt_plugin_pluginutils_09ab66c3(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_598c2ed7 === 'function') {
    await nuxt_plugin_pluginseo_598c2ed7(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_026d4f4e === 'function') {
    await nuxt_plugin_pluginrouting_026d4f4e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_d8eee23e === 'function') {
    await nuxt_plugin_pluginmain_d8eee23e(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugind555f224_52874b51 === 'function') {
    await nuxt_plugin_distplugind555f224_52874b51(app.context, inject)
  }

  if (typeof nuxt_plugin_image_beee791a === 'function') {
    await nuxt_plugin_image_beee791a(app.context, inject)
  }

  if (typeof nuxt_plugin_coreplugin3cbad86a_42542c88 === 'function') {
    await nuxt_plugin_coreplugin3cbad86a_42542c88(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginse2etesting99e2c82a_6527f86e === 'function') {
    await nuxt_plugin_pluginse2etesting99e2c82a_6527f86e(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_27076603 === 'function') {
    await nuxt_plugin_deviceplugin_27076603(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_440b04d8 === 'function') {
    await nuxt_plugin_workbox_440b04d8(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_2716f0a7 === 'function') {
    await nuxt_plugin_metaplugin_2716f0a7(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_2bbe961b === 'function') {
    await nuxt_plugin_iconplugin_2bbe961b(app.context, inject)
  }

  if (typeof nuxt_plugin_tokenexpired_ca1e20ca === 'function') {
    await nuxt_plugin_tokenexpired_ca1e20ca(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_fcPlugin_5a846bc6 === 'function') {
    await nuxt_plugin_fcPlugin_5a846bc6(app.context, inject)
  }

  if (typeof nuxt_plugin_dompurify_9e093c4a === 'function') {
    await nuxt_plugin_dompurify_9e093c4a(app.context, inject)
  }

  if (typeof nuxt_plugin_storeConfigPlugin_234467e0 === 'function') {
    await nuxt_plugin_storeConfigPlugin_234467e0(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_77b6055c === 'function') {
    await nuxt_plugin_meta_77b6055c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
